import { ReactNode } from "react";

const URL_REGEX = /(https?:\/\/[^\s]+|www\.[^\s]+)/gi;

const TRAILING_PUNCT = /[.,!?;:)\]}>'"]+$/;

export const linkify = (text?: string): ReactNode => {
  if (!text) return text ?? "";

  const nodes: ReactNode[] = [];
  let lastIndex = 0;
  let key = 0;
  let match: RegExpExecArray | null;
  URL_REGEX.lastIndex = 0;

  while ((match = URL_REGEX.exec(text)) !== null) {
    const raw = match[0];
    const start = match.index;

    const trailing = raw.match(TRAILING_PUNCT)?.[0] ?? "";
    const url = trailing ? raw.slice(0, raw.length - trailing.length) : raw;
    const href = url.startsWith("http") ? url : `https://${url}`;

    if (start > lastIndex) nodes.push(text.slice(lastIndex, start));

    nodes.push(
      <a
        key={`lnk-${key++}`}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="underline break-all"
        onClick={(e) => e.stopPropagation()}
      >
        {url}
      </a>,
    );

    if (trailing) nodes.push(trailing);
    lastIndex = start + raw.length;
  }

  if (lastIndex < text.length) nodes.push(text.slice(lastIndex));

  return nodes;
};
